"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const upload_cosmos_md_svg_1 = require("components/svg/icons/upload-cosmos-md.svg");
const translate_1 = require("components/translate");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const events_1 = __importDefault(require("modules/content/events"));
const DisabledOnOnlineEvent_1 = __importDefault(require("modules/onlineEvent/components/DisabledOnOnlineEvent"));
const BulkUploadButtonEvents_1 = require("./BulkUploadButtonEvents");
const club_files_ui_1 = require("@hotmart/club-files-ui");
const BulkUploadButton = ({ t, className, isMobile = false }) => {
    const [showClubLibraryProviderModal, setShowClubLibraryProviderModal] = (0, react_1.useState)(false);
    const handleAddFilesClick = () => {
    };
    const handleClick = () => {
        events_1.default.sendClick({ label: 'UploadFiles' });
        (0, BulkUploadButtonEvents_1.sendUploadFilesEvent)();
        setShowClubLibraryProviderModal(true);
    };
    const handleCloseBulkUpload = () => {
        setShowClubLibraryProviderModal(false);
    };
    return ((0, jsx_runtime_1.jsxs)(DisabledOnOnlineEvent_1.default, { children: [(0, jsx_runtime_1.jsxs)(button_1.default, { variation: "secondary", size: isMobile ? 'block' : 'md', className: className, "data-track": "content-content-management-files-upload", onClick: handleClick, children: [(0, jsx_runtime_1.jsx)(upload_cosmos_md_svg_1.ReactComponent, { className: "_mr-2" }), t('content_list.add_files')] }), (0, jsx_runtime_1.jsx)(club_files_ui_1.BulkUpload, { isOpen: showClubLibraryProviderModal, onAddFilesClick: handleAddFilesClick, onClose: handleCloseBulkUpload })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    isMobile: stores.UiStore.isMobile
})))(BulkUploadButton);
